module.exports = __webpack_public_path__ + "static/img/leader3.16e9525.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/leader3.png
// module id = BdfO
// module chunks = 1